const isTouchDevice = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    return 'ontouchstart' in window || (window.navigator && window.navigator.maxTouchPoints > 0);
};

export const DROPDOWN_CONFIG = {
    filter : true,
    autoWidth : true,
    showClear : true,
    // position : isTouchDevice() ? 'bottom' : 'top',
    // ...(isTouchDevice() ? {} : { appendTo : document.body }),
    appendTo: document.body,
    dataKey : "value",
    filterBy : "label,value,id,userId" ,
    filterInputAutoFocus: isTouchDevice() ? false : true
}

export const DATATABLE_CONFIG = {
    paginator : true,
    responsive: true,
    rowHover: true,
    className : "p-datatable-customers animated fadeIn",
    rows : 10,
    emptyMessage : "No data found",
    rowsPerPageOptions: [5,10,20],
    paginatorTemplate : "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
    currentPageReportTemplate : '({currentPage} of {totalPages})' ,
}

export const CALENDAR_CONFIG = {
    readOnlyInput : true,
    showIcon : true
}


/* Leave Request */
export const EXAMINATION_ID= 'e5cdb5b2-4fcb-4dbd-b22e-96a35e386968';
export const LEAVE_REQUEST_ID= 'B5585767-17F2-43D4-979B-EFD170B4C3FA';
export const ADDITIONAL_LEAVE_QUOTA_ID = '67002418-62bc-48c3-b427-0a43f7195860';
export const CARRY_FORWARD_ANNUAL_LIST = 'EAECF543-5A3C-41AC-B6D3-D9CF596D02FB';
export const CALL_BACK_LEAVE_ID = '115534c5-8c18-4833-9127-1d903c8f2317';

/* Master Pages */
export const EMPLOYEE_SUBMENU_ID = '7e38e0f0-df8c-4448-95f6-1e22d069b4aa';
export const ORG_SUBMENU_ID = '2f35ecf7-9427-48b5-99fa-1e30c2b182c8';
export const POSITION_SUBMENU_ID = '0b855dff-ae76-4539-ae39-210ea3d9e1c3';
export const TIMEOFFTYPE_SUBMENU_ID = 'e327bb27-a78a-416f-9a35-450f88cea255';
export const POLICY_SUBMENU_ID = '280812db-9bdd-4098-8185-bece59bb55ba';
export const APPROVAL_TYPE_SUBMENU_ID = '2e2cd887-7d7f-46db-b89d-51a8677b7001';
export const APPROVAL_PATH_SUBMENU_ID = 'c99ef8c0-b06a-42ee-832b-5de684c3d854';
export const KEYWORD_SUBMENU_ID = 'c3ae7281-fc99-41a5-8cab-6d5f2444c88a';
export const HOLIDAY_SUBMENU_ID = '2ee7f298-14f7-48c3-a524-7f0f4cd2a89d';
export const NUMBER_SUBMENU_ID = 'fb2565a3-4bf7-4fcb-80d5-9e0cc01c1f3d';
export const USER_SUBMENU_ID = '649ca4f1-6fde-4567-b469-a18669631a89';
export const DAILY_SHIFT_SUBMENU_ID = '286fa681-e3d8-4047-84d3-add05fb728ae';
export const EMP_GROUP_SUBMENU_ID = 'c541fd84-5c98-47e6-bea2-b96dbea4a9b7';
export const ROLES_SUBMENU_ID = '0b855dff-ae76-4539-ae39-210ea3d9e1c4';
export const NEWS_SUBMENU_ID = '7e38e0f0-df8c-4448-95f6-1e22d069b5aa';
export const POLICY_ATTACHMENT_SUBMENU_ID = '7e38e0f0-df8c-4448-95f6-1e22d069b6aa';
export const COMPANY_SUBMENU_ID = '7e38e0f0-df8c-4448-95f6-1e22d069b7aa';
export const SHIFT_SUBMENU_ID = '7e38e0f0-df8c-4448-95f6-1e22d069b8aa';
export const HELP_SUBMENU_ID = '7e38e0f0-df8c-4448-95f6-1e22d169b5aa';
export const ORGCHART_SUBMENU_ID = '7e38e9f0-df8c-4448-95f6-1e22d369b5aa';
export const POSCHART_SUBMENU_ID = '7e38e9f2-df8c-4448-95f6-1e22d369b5aa';
export const PROCESS_SUBMENU_ID = '280912db-9bdd-4098-8185-bece59bb55ba';
export const PUNCH_EDITING_SUBMENU_ID = 'aa94f834-7bf1-472e-ad94-17aca14389ff';
export const WORK_PERMIT_SUBMENU_ID = '43eb66e9-6d3a-460d-93ae-be99c9acaf5d';
export const CERTIFICATE_MASTER_SUBMENU_ID = 'aa94f834-7bf1-472e-ad94-17aca14391ff';
export const WPSTATUS_MASTER_SUBMENU_ID = 'aa94f834-7bf1-472e-ad94-17aca14390ff';
export const KPI_SUBMENU_ID = '281012db-9bdd-4098-8185-bece59bb55ba';
export const SLA_SUBMENU_ID = '7a7241bc-dbcd-4935-a899-c21f0f8833c2';
export const ESCLATION_SUBMENU_ID = '7a7251bc-dbcd-4935-a899-c21f0f8833c2';
export const PROJECT_SUBMENU_ID = 'aa94f834-7bf1-472e-ad94-17aca14491ff';
export const VENDOR_SUBMENU_ID = 'aa94f834-7bf1-472e-ad94-17aca14291ff';
export const PEOPLE_SUBMENU_ID = '280912db-8bdd-4098-8185-bece50bb55ba';

/* ZATCA e-invoicing —  testing purpose added user_submenu)_id */
export const ZATCA_COMPANY_SUBMENU_ID = USER_SUBMENU_ID;
export const ZATCA_UNIT_SUBMENU_ID = USER_SUBMENU_ID;
export const ZATCA_MONITOR_SUBMENU_ID = USER_SUBMENU_ID;

/* Master Pages */



/* Dashboard Pages */
export const MYTEAM_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd63646b8f';
export const LEAVEBALANCE_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd65646b8f';
export const MYTEAM_LEAVE_RECORD_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd66646b8f';
export const MYTEAM_ATTENDANCE_RECORD_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd67646b8f';
export const VIDEO_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd62646b4f';
export const NEWS_DASHBOARD_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd62646b5f';
export const REQSTATISTICS_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd62646b6f';
export const INBOX_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd62646b7f';
export const HOLIDAY_DASHBOARD_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd62646b9f';
export const MYLEAVEBAL_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd62647b4f';
export const LEAVECHART_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd62648b4f';
export const CALENDAR_SUBMENU_ID = '818c7383-9f03-4cfa-aa2e-c8cd62646b7f';
export const ATTNCHART_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd62649b4f';
export const SCHEDULE_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd68646b8f';
export const ATTENDANCECHART_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd69646b8f';
export const RECRUITMENT_SUBMENU_ID = '818c7393-9f13-4cfa-aa2e-c8cd69646b8f';
export const WCA_STATISTICS_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd71646b8f';
export const SAFETY_CONTROLLER_LIST_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd72646b8f';
export const ACCEPTOR_LIST_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd73646b8f';
export const WCA_INBOX_SUBMENU_ID = '818c7393-9f03-4cfa-aa2e-c8cd74646b8f';
export const HEADCOUNT_CHART_ID = '818c7393-9f03-4cfa-aa2e-c8cd75646b8f'
export const LEAVE_HEADCOUNT_CHART_ID = '818c7393-9f03-4cfa-aa2e-c8cd75646b9f'
/* Dashboard Pages */


/* WorkSchedule */
export const WORK_SCHEDULE_ID = 'DB4BCCF0-4446-464E-BA88-28991BD6ACEC';

export const WORK_SCHEDULE_SINGLE_ID = 'DB5BCCF0-4446-464E-BA88-28991BD6ACEC';

/* Payroll Report */
export const PAYROLL_REPORT_ID = '1D997738-6764-4DAB-ADBB-F403CD5AE13B';

/* Flexible Timing */
export const FLEXIBLE_TIMING_ID = "dd5d6bd4-11eb-47e7-89fe-b32252480b20";

/* Vacation Plan */
export const VACATION_PLAN_ID = '7a84fcb0-58e8-4efc-9fdb-1f6557423fbc';


/* Over time Pre approval */
export const OVERTIME_PREAPPROVAL_ID = 'ecf9cf7a-f3b8-45ef-aa08-4b77d59d1076';


/* Break Permission */
export const BREAK_PERMISSION_ID = '49c4ee4c-fb3e-43f3-bcf4-6dac36a9549b';


/* Leave Cancellation */
export const LEAVE_CANCELLATION_ID = 'c2b72b23-7d5d-45ba-aac2-525c5eae25d1';

/* TImeSheet */
export const TIMESHEET_ID = 'b5585767-17f2-43d4-979b-efd191b4c3fa';


/* Job Requisition */
export const JOB_REQUISITIONS_ID = 'C59287F6-537F-4D4E-B611-D67C5BFC85E4';


/* ShortListing */
export const SHORT_LISTING_ID = 'C6690E3C-2CD7-4087-B3B3-A79EAA66933F';


/* Interview */
export const JOB_INTERVIEW_ID = '08AA6CC6-A0FC-4208-AED1-4B768822F785';

/* Ranking and Selection */
export const RANKING_PROCESS_ID = 'EBD3405C-C742-4939-A1A8-AFBCE851BDEA';

/* Joining and followon actions */
export const JOINING_PROCESS_ID = 'A918DDF4-C396-477C-97C5-2896ED8F82D3';

/* Job Application */
export const JOB_APPLICATION_ID = '5FDB1A1B-E1F2-4203-AC81-0665FDFBFF73';


/* Travel Authorization ID */
export const TRAVEL_AUTHORIZATION_ID = '8AE27597-ADB2-491D-B592-7847A733BC05';



/* Reports Authorization ID */
export const REPORTS_ID = '72c511d7-cbe2-42dd-ac09-25c8639d9b49';

/* Business Trip Expense Claim */
export const BUSINESS_TRIP_ID = '03C893B0-D69C-488D-9BD3-FBC55845F68F';


/*Gate pass  visitor*/
export const GATEPASS_VISITOR_ID = 'E8A2F12B-6E40-4997-9EB9-B73A8948027D';

/*Gate pass  Matertial Pass In*/
export const MATERIAL_PASS_IN_ID = 'E8A2F12B-6E40-4997-9EB9-B73A8948024D';

/*Gate pass  Matertial Pass Out*/
export const MATERIAL_PASS_OUT_ID = 'E8A2F12B-6E40-4997-9EB9-B73A8948025D';

/*Gate pass  Vehicle*/
export const MATERIAL_PASS_VEHICLE_ID = 'E8A2F12B-6E40-4997-9EB9-B73A8948026D';

/*SAP Work Permit*/
export const WORK_PERMIT_ID = '236D1C03-5B22-480E-B32F-8F48B4882FA5';

/*Process Incindent Report*/
export const PROCESS_INCIDENT_REPORT_ID = '236D1C03-5B22-480E-B32F-8F48B4882FA6';

/*Simulation Process*/ 
export const SIMULATION_ID = '236D1C03-5B22-480E-B32F-8F48B4882FA8';

/*Plant Modification(MOC) Process*/
export const MOC_ID = '236D1C03-5B22-480E-B32F-8F48B4882FA7';

/*Plant Temporary Modification(MOC) Process*/
export const TMOC_ID = '236D1C03-5B22-480E-B32F-8F48B4882FA9';

/*Service*/
export const SERVICE_ID = 'EDAACF09-A54A-4AD7-890B-6E3DE0C9C0E0';

/*Monthly Evaluation*/
export const MONTHLY_EVALUATION_ID = '87235065-bb19-45f9-b881-026536ea4486';
/*HDS Incident Management*/
export const HDS_INCIDENT_ID = 'f7ca50fc-d109-4e1d-8cba-c02141d79622';
/*HDS Problem Management*/
export const HDS_PROBLEM_ID = '7a7231bc-dbcd-4935-a899-c21f0f8833c2';
/*HDS Change Management*/
export const HDS_CHANGE_ID = 'db28d8f9-6c09-4ebb-ac4c-890dbf433685';

/*KPI Target*/
export const KPI_TARGET_ID = 'fee46a43-9bc6-4f17-b304-7419be3e6ae6';
/*KPI Actual*/
export const KPI_ACTUAL_ID = '5e38d332-d688-49c2-833f-1103834a5c81';
/*KPI Actual*/
export const FI_INVOICE_ID = '4548BD63-B15C-4407-B5D5-3E3C33388110';

/* HR ANALYTICS*/
export const HR_ANALYTICS = '03c803b0-d69c-488d-9bd3-fbc55845f80f';
export const OM_ANALYTICS = '03c803b0-d69c-488d-9bd3-fbc55845f70f';

/* Advance Request*/

export const AdvanceRequest_ID = 'E8BBD4AE-C146-4548-AD7E-78126396C700';

/*Event Management */
export const EVENT_MANAGEMENT_ID = '00c63aef-1089-4b9e-a5b4-be972690caea';
export const COSTCENTER_ID = '280912db-9bdd-4098-8185-bece50bb55ba';



export const TIMEBOOKING_ID = '22fd47a1-5cf6-4450-9dfe-aef9348df6d0';
export const DEMOBLIZATION_ID = '1cf4350f-2845-4246-afe2-80aaf5a7b712';
export const MOBLIZATION_ID = 'f4116c36-7a1c-4138-89b5-9fd42ce09ff1';
export const VENDORREGISTRATION_ID = '1c3737f9-fe37-48d3-aea2-a9d3a4a3390a';



export const EMPLOYEE_LOAN_ID = 'EFB68FED-BFB6-4FE7-A8FE-9C9902C6B25E';
export const DAILY_ACTIVITY_ID = '981C486D-CBCD-4122-91F8-148C34BFC3E2';

export const PURCHASE_ORDER_ID = '150C004C-AF7B-4213-8726-1AF81899B75C';
export const GRN_ID = 'DA4B2039-A2EA-4B35-BF70-F01678792ABB';
export const WASTAGE_ID = '24D56B09-3A1A-4A33-833A-E2E5E7E023AB';
export const PURCHASE_RETURN_ID = '2AE4D864-B447-4F37-86EF-2C34626E3B6D';
export const REQUEST_FOR_QUOTATION_ID = '93E25A30-FCF3-4111-88AF-F4FD6357FB5A';
export const SUPPLIER_QUOTATION_ID = '3DC9EABD-6305-4A63-BD33-5B9F54B87547';

export const CALENDAR_NEW_SUB_MENU_ID = 'C59287F6-537F-4D4E-B611-D67C5BFC05E4';
export const HEADCOUNT_NEW_SUB_MENU_ID = 'C59287F6-537F-4D4E-B611-D67C5BFC95E4';

//Propert Management 
export const TENANT_ID = 'c3ae7281-fc99-41a5-8cab-6d5f2444c98a'
export const TENANT_ZONE_ID = 'c3ae7281-fc99-41a5-8cab-6d5f2444c08a'
export const PROPERTY_GROUP_ID = 'c3ae7281-fc99-41a5-8cab-6d5f2444c18a'
export const PROPERTY_ID = 'c3ae7281-fc99-41a5-8cab-6d5f2444c28a'
export const PROPERTY_SERVICE_ID = 'c3ae7281-fc99-41a5-8cab-6d5f2444c38a'

export const OPENING_STOCK_ID = '362BB028-9645-44D2-9103-9EBAF77E30D2';
export const PHYSICAL_STOCK_ID = '18464CB6-6867-4E3C-AE79-B7143B714001';
export const MENU_FORECAST_ID = 'FE531062-B1F7-43C2-92CC-223648270382';
export const PRODUCTION_PLANNING_ID = '903F0D93-9E5F-4DB1-AAEE-6C0BE0197AB4';
export const PURCHASE_REQUISITION_ID = '04401403-4cf7-4372-b640-a927ba17fd3f';
export const MATERIAL_REQUIREMENT_PLANNING_ID = '397F83FA-D8B5-4813-AF69-13E5034F76E1';
export const IMPREST_SYSTEM_ID = '22D1E783-A389-4594-9D2E-381BEE752C9B';
export const JOURNAL_VOUCHER_ID = '1249B22C-53E2-4421-99F2-BEF2E1A4AB3D';
export const CAMPAIGN_ID = '101D3793-8558-4361-BE22-E91B7FFBBEBD';
export const SALES_ORDER_ID = '40E5AF2B-06A9-41AD-9005-009793FA346D';
export const STOCK_ADJUSTMENT_ID = '18464CB6-6867-4E3C-AE79-B7143B714001';

export const TABLE_RESERVATION_PROCESS_ID = 'b1f0b0ec-df1d-414b-bd09-9aed7f0ba1bb';




export const Companyid ='414FE8CA-61AA-4876-8FA5-22940150212E' ;

// QR ordering — anonymous customer identity. TODO: create one real "QR Guest"
// Employee record via the Employee master UI (zero role/menu permissions),
// then replace these two placeholders with its real EmpId/userID. Both are
// needed — authCheckState/authSuccess/getUserDetails read EmpId and userID
// as distinct localStorage keys (see QrGuestGate.js).
export const QR_GUEST_EMP_ID = 'aafb6307-bd20-412c-8065-fcd1eca613a1';
export const QR_GUEST_USER_ID = 'aafb6307-bd20-412c-8065-fcd1eca613a1';

// Marks a session that Order List / Production Plan started by signing in as
// the guest account, so POSApp keeps rendering those pages without the staff
// shell for the life of that session. Shared here because POSApp and both
// pages must agree on the exact key. logout() clears localStorage, so the
// marker cannot outlive the session it describes.
export const POS_GUEST_SESSION_KEY = 'posGuestSession';

// QR ordering — location gate. TODO: replace with the real branch coordinates
// and the intended order radius before going live (LocationGate.js).
export const BRANCH_LOCATION = {
    latitude: 8.554139916123068,
    longitude: 78.09900066529698,
    radiusMeters: 300,
};

